import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const FlashLoaderContext = createContext();

export const useFlashLoaderLoader = () => useContext(FlashLoaderContext);

export const FlashLoaderProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const value = useMemo(
    () => ({
      showLoader: async () => setIsLoading(true),
      hideLoader: async () => setIsLoading(false),
    }),
    [],
  );

  return (
    <FlashLoaderContext.Provider value={value}>
      {isLoading && <GlobalLoader />}
      {children}
    </FlashLoaderContext.Provider>
  );
};

const GlobalLoader = () => (
  <div id="flashPanel" className="loader-overlay flashScreen">
    <div className="spinner"></div>
  </div>
);
